import React from "react";
import { SimpleGrid, Flex, Heading } from "@chakra-ui/react";
import Avatar from "@/components/common/Avatar";
import BoxCard from "@/components/common/BoxCard";
import ContactInfo from "./ContactInfo";
import { MapPin, Mail, Phone } from "react-feather";
import { Website } from "@/types/website";

type Props = {
  website: Website;
  rounded?: boolean;
};

const Contact = ({ website, rounded }: Props): React.ReactElement => {
  const contacts = website?.contacts ?? [];

  return (
    <>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
        {contacts.map((contact) => (
          <BoxCard key={contact.id} borderRadius={rounded ? ".375rem" : 0}>
            <Flex mb={5} align="center">
              <Avatar name={contact.name} size="md" mr={4} />
              <Heading size="md" as="h3" mb={0}>
                {contact.name}
              </Heading>
            </Flex>
            {contact.address && (
              <ContactInfo ico={MapPin} value={contact.address} />
            )}
            <ContactInfo ico={Mail} value={contact.email} />
            <ContactInfo ico={Phone} value={contact.phone} />
          </BoxCard>
        ))}
      </SimpleGrid>
    </>
  );
};

export default Contact;
